import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=727b7d99&scoped=true&"
import script from "./PageHero.vue?vue&type=script&lang=js&"
export * from "./PageHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727b7d99",
  null
  
)

export default component.exports